export const INDEXING_REQUESTED_EVENT = 'kea:indexing-requested';
export const INDEXING_REQUEST_FAILED_EVENT = 'kea:indexing-request-failed';
export const REINDEX_REQUIRED_EVENT = 'kea:reindex-required';

function dispatchWindowEvent(eventName, detail = {}) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return false;
  }

  const eventDetail = {
    requestedAt: Date.now(),
    ...detail,
  };
  let event;
  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: eventDetail });
  } else if (typeof CustomEvent === 'function') {
    event = new CustomEvent(eventName, { detail: eventDetail });
  } else if (typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, false, false, eventDetail);
  } else {
    return false;
  }

  window.dispatchEvent(event);
  return true;
}

function subscribeToWindowEvent(eventName, handler) {
  if (
    typeof window === 'undefined'
    || typeof window.addEventListener !== 'function'
    || typeof window.removeEventListener !== 'function'
  ) {
    return () => {};
  }

  const listener = (event) => {
    handler(event?.detail || {});
  };
  window.addEventListener(eventName, listener);
  return () => window.removeEventListener(eventName, listener);
}

export function notifyIndexingRequested(detail = {}) {
  return dispatchWindowEvent(INDEXING_REQUESTED_EVENT, detail);
}

export function notifyIndexingRequestFailed(detail = {}) {
  return dispatchWindowEvent(INDEXING_REQUEST_FAILED_EVENT, detail);
}

export function notifyReindexRequired(detail = {}) {
  return dispatchWindowEvent(REINDEX_REQUIRED_EVENT, detail);
}

export function subscribeToIndexingRequested(handler) {
  return subscribeToWindowEvent(INDEXING_REQUESTED_EVENT, handler);
}

export function subscribeToIndexingRequestFailed(handler) {
  return subscribeToWindowEvent(INDEXING_REQUEST_FAILED_EVENT, handler);
}

export function subscribeToReindexRequired(handler) {
  return subscribeToWindowEvent(REINDEX_REQUIRED_EVENT, handler);
}
